"use client";

import React from "react";

interface TailwindLoadingProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  variant?: "multicolor" | "single";
  color?: "blue" | "pink" | "green" | "purple" | "gray";
}

const TailwindLoading: React.FC<TailwindLoadingProps> = ({
  size = "md",
  className = "",
  variant = "multicolor",
  color = "blue",
}) => {
  const sizeClasses = {
    sm: "w-1.5 h-1.5",
    md: "w-2.5 h-2.5",
    lg: "w-4 h-4",
  };

  const dotSize = sizeClasses[size];

  // Multicolor variant - Custom pastel colors
  if (variant === "multicolor") {
    return (
      <div className={`flex items-center justify-center space-x-3 ${className}`}>
        <div
          className={`${dotSize} rounded-full animate-bounce`}
          style={{
            backgroundColor: "#7BAAF7", // xanh dương nhạt
            animationDelay: "0ms",
            animationDuration: "1s",
          }}
        />
        <div
          className={`${dotSize} rounded-full animate-bounce`}
          style={{
            backgroundColor: "#E29DB1", // hồng pastel
            animationDelay: "160ms",
            animationDuration: "1s",
          }}
        />
        <div
          className={`${dotSize} rounded-full animate-bounce`}
          style={{
            backgroundColor: "#B7D592", // xanh lá nhạt
            animationDelay: "320ms",
            animationDuration: "1s",
          }}
        />
      </div>
    );
  }

  // Single color variant - Custom pastel colors
  const colorHex = {
    blue: "#7BAAF7", // xanh dương nhạt
    pink: "#E29DB1", // hồng pastel
    green: "#B7D592", // xanh lá nhạt
    purple: "#C8A8E9", // tím pastel (thêm màu)
    gray: "#D1D5DB", // xám nhẹ
  };

  const selectedColor = colorHex[color];

  return (
    <div className={`flex items-center justify-center space-x-3 ${className}`}>
      <div
        className={`${dotSize} rounded-full animate-bounce`}
        style={{ backgroundColor: selectedColor, animationDelay: "0ms", animationDuration: "1s" }}
      />
      <div
        className={`${dotSize} rounded-full animate-bounce`}
        style={{ backgroundColor: selectedColor, animationDelay: "160ms", animationDuration: "1s" }}
      />
      <div
        className={`${dotSize} rounded-full animate-bounce`}
        style={{ backgroundColor: selectedColor, animationDelay: "320ms", animationDuration: "1s" }}
      />
    </div>
  );
};

export default TailwindLoading;
